//get background image
import LogoS from "../assets/logosWhite.png";

function LogoForHeader(){
  
    return <img className=" h-36 w-30 -mt-12 cursor-pointer" src={LogoS} alt=""/>
}

export default LogoForHeader;